import { useGenericRoles } from '@infuse/iam/role/queries';
import { searchTenantRoles } from '@infuse/api/iam/tenant';

export const useTenantRoles = () => {
  return useGenericRoles({
    apiFn: searchTenantRoles,
    queryKeys: ['roles', 'tenant'],
    onlyEnableWithParentId: true
  });
};
